export interface HighlightDefinition {
  description: string; // translation key
  // ISO date, e.g. "2026-12-01": nobody sees the highlight from then on, so users who join later aren't flooded
  until: string;
  learnMore?: () => void;
}

// A key is stored in the seen-state: a new key shows again to users who used or outlived an older one.
export const featureHighlights = {
  map: { description: /*$t*/ "mapModal.description", until: "2026-12-01" },
  signals: { description: /*$t*/ "signals.highlight", until: "2026-12-31" },
} satisfies Record<string, HighlightDefinition>;

export type FeatureHighlightId = keyof typeof featureHighlights;

export interface FeatureHighlight {
  id: FeatureHighlightId;
  description: string;
  learnMore?: () => void;
}

export const defaultHighlightDays = 5;

// shorter than the usual tooltip delay: the tooltip is the only place that explains the highlight
export const highlightTooltipDelay: [number, number] = [150, 50];
